module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui container view"
  }, [_c('div', {
    staticClass: "ui vertically divided grid"
  }, [_c('div', {
    staticClass: "two column row"
  }, [_c('div', {
    staticClass: "ten wide column"
  }, [_c('table', {
    staticClass: "ui compact celled table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.quoteAggregates.components), function(component) {
    return _c('quote-component', {
      attrs: {
        "component": component,
        "quote-params": _vm.quoteParams
      }
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "six wide column"
  }, [_c('table', {
    staticClass: "ui compact celled table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.quoteAggregates.fixed_cost_items), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "right aligned"
    }, [_vm._v(_vm._s(_vm._f("currency")(item.amount)))])])
  })), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "total"
  }, [_c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', {
    staticClass: "right aligned"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.quoteAggregates.fixed_cost_items_amount)))])])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("Estimate Components")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Fixed Cost Items")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ee68da88!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Summary.vue
// module id = 227
// module chunks = 2